import script from "./Loader.vue?vue&type=script&setup=true&lang=js"
export * from "./Loader.vue?vue&type=script&setup=true&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=b1f671d0&lang=css"

const __exports__ = script;

export default __exports__